var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { APPEvent } from "@/events/AppEvents";
import { Apphandler } from "@/ipc/MainAppHandler";
import { action, makeObservable, observable } from "mobx";
export class LoginViaDeviceUIStore {
    constructor() {
        this.error = "";
        this.showerror = false;
        this.appid = "";
        this.appcode = "";
        this.height = 0;
        this.registering = false;
        this.mydevicecode = Math.floor((Math.random() * 10000000));
        makeObservable(this);
        APPEvent.addSubscriberForLoginViaDevice((res) => {
            if (res) {
            }
            this.setRegistering(false);
        });
    }
    setRegistering(reg) {
        this.registering = reg;
    }
    reset() {
    }
    setShowError(error) {
        this.showerror = error;
    }
    setErrorMessage(msg) {
        this.error = msg;
    }
    setHeight(hg) {
        this.height = hg;
    }
    setAppCode(code) {
        this.appcode = code;
    }
    setAppId(id) {
        this.appid = id;
    }
    resetDeviceCode() {
        this.mydevicecode = Math.floor((Math.random() * 10000000));
    }
    async login() {
        if (!this.appcode || !this.appid) {
            this.setErrorMessage("App code and app id can't be empty");
            this.setShowError(true);
            return;
        }
        this.setRegistering(true);
        const req = {
            devicecode: this.mydevicecode,
            appcode: this.appcode,
            appid: this.appid
        };
        Apphandler.sendMessage("loginviadevice", req);
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], LoginViaDeviceUIStore.prototype, "error", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LoginViaDeviceUIStore.prototype, "showerror", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LoginViaDeviceUIStore.prototype, "appid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LoginViaDeviceUIStore.prototype, "appcode", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LoginViaDeviceUIStore.prototype, "height", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LoginViaDeviceUIStore.prototype, "registering", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], LoginViaDeviceUIStore.prototype, "setRegistering", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], LoginViaDeviceUIStore.prototype, "reset", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], LoginViaDeviceUIStore.prototype, "setShowError", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LoginViaDeviceUIStore.prototype, "setErrorMessage", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], LoginViaDeviceUIStore.prototype, "setHeight", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LoginViaDeviceUIStore.prototype, "setAppCode", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LoginViaDeviceUIStore.prototype, "setAppId", null);
